// app/layout.tsx
'use client';
import './globals.css';
import StoreProvider from './StoreProvider';
import initializeApp from '@/lib/init-app';
import BgSVG from '../../public/Bg.svg';
import { SessionProvider } from '@/contexts/session.context';
import { ToastContainer } from 'react-toastify';
import { SocketProvider } from '@/contexts/socket.context';

// Initialize different libraries
initializeApp();
export default function RootLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <html
      lang="en"
      data-theme="gotham-light"
      className="bg-base-200 h-full overflow-hidden"
      style={{
        backgroundImage: `url(${BgSVG.src})`,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed',
        backgroundPosition: 'right bottom',
      }}
    >
      <body className="h-full overflow-hidden flex flex-col">
        <SocketProvider>
          <StoreProvider>
            <SessionProvider>{children}</SessionProvider>
            <ToastContainer />
          </StoreProvider>
        </SocketProvider>
      </body>
    </html>
  );
}
